export class CountryCodes {
    static readonly LIST = [
        { label: '+971', code: '971', full_code: '🇦🇪 +971', name: 'AE' },
        { label: '+1', code: '1', full_code: '🇺🇸 +1', name: 'US' },
        { label: '+44', code: '44', full_code: '🇬🇧 +44', name: 'GB' },
        { label: '+91', code: '91', full_code: '🇮🇳 +91', name: 'IN' },
        { label: '+61', code: '61', full_code: '🇦🇺 +61', name: 'AU' },
        { label: '+81', code: '81', full_code: '🇯🇵 +81', name: 'JP' },
        { label: '+49', code: '49', full_code: '🇩🇪 +49', name: 'DE' },
        { label: '+33', code: '33', full_code: '🇫🇷 +33', name: 'FR' },
        { label: '+39', code: '39', full_code: '🇮🇹 +39', name: 'IT' },
        { label: '+86', code: '86', full_code: '🇨🇳 +86', name: 'CN' },
        { label: '+7', code: '7', full_code: '🇷🇺 +7', name: 'RU' },
        { label: '+34', code: '34', full_code: '🇪🇸 +34', name: 'ES' },
        { label: '+55', code: '55', full_code: '🇧🇷 +55', name: 'BR' },
        { label: '+27', code: '27', full_code: '🇿🇦 +27', name: 'ZA' },
        { label: '+82', code: '82', full_code: '🇰🇷 +82', name: 'KR' },
        { label: '+965', code: '965', full_code: '🇰🇼 +965', name: 'KW' },
        { label: '+974', code: '974', full_code: '🇶🇦 +974', name: 'QA' },
        { label: '+966', code: '966', full_code: '🇸🇦 +966', name: 'SA' },
        { label: '+968', code: '968', full_code: '🇴🇲 +968', name: 'OM' },
        { label: '+962', code: '962', full_code: '🇯🇴 +962', name: 'JO' },
        { label: '+964', code: '964', full_code: '🇮🇶 +964', name: 'IQ' },
        { label: '+20', code: '20', full_code: '🇪🇬 +20', name: 'EG' },
        { label: '+961', code: '961', full_code: '🇱🇧 +961', name: 'LB' },
        { label: '+90', code: '90', full_code: '🇹🇷 +90', name: 'TR' },
        { label: '+66', code: '66', full_code: '🇹🇭 +66', name: 'TH' },
        { label: '+60', code: '60', full_code: '🇲🇾 +60', name: 'MY' },
        { label: '+63', code: '63', full_code: '🇵🇭 +63', name: 'PH' },
        { label: '+62', code: '62', full_code: '🇮🇩 +62', name: 'ID' },
        { label: '+65', code: '65', full_code: '🇸🇬 +65', name: 'SG' },
        { label: '+353', code: '353', full_code: '🇮🇪 +353', name: 'IE' },
        { label: '+43', code: '43', full_code: '🇦🇹 +43', name: 'AT' },
        { label: '+31', code: '31', full_code: '🇳🇱 +31', name: 'NL' },
        { label: '+32', code: '32', full_code: '🇧🇪 +32', name: 'BE' },
        { label: '+46', code: '46', full_code: '🇸🇪 +46', name: 'SE' },
        { label: '+47', code: '47', full_code: '🇳🇴 +47', name: 'NO' },
        { label: '+41', code: '41', full_code: '🇨🇭 +41', name: 'CH' },
        { label: '+380', code: '380', full_code: '🇺🇦 +380', name: 'UA' },
        { label: '+359', code: '359', full_code: '🇧🇬 +359', name: 'BG' },
        { label: '+40', code: '40', full_code: '🇷🇴 +40', name: 'RO' },
        { label: '+420', code: '420', full_code: '🇨🇿 +420', name: 'CZ' },
        { label: '+421', code: '421', full_code: '🇸🇰 +421', name: 'SK' },
        { label: '+48', code: '48', full_code: '🇵🇱 +48', name: 'PL' },
        { label: '+36', code: '36', full_code: '🇭🇺 +36', name: 'HU' },
        { label: '+52', code: '52', full_code: '🇲🇽 +52', name: 'MX' },
        { label: '+351', code: '351', full_code: '🇵🇹 +351', name: 'PT' },
        { label: '+994', code: '994', full_code: '🇦🇿 +994', name: 'AZ' },
        { label: '+973', code: '973', full_code: '🇧🇭 +973', name: 'BH' },
        { label: '+880', code: '880', full_code: '🇧🇩 +880', name: 'BD' },
        { label: '+977', code: '977', full_code: '🇳🇵 +977', name: 'NP' },
        { label: '+94', code: '94', full_code: '🇱🇰 +94', name: 'LK' },
        { label: '+92', code: '92', full_code: '🇵🇰 +92', name: 'PK' },
        { label: '+248', code: '248', full_code: '🇸🇨 +248', name: 'SC' },
        { label: '+963', code: '963', full_code: '🇸🇾 +963', name: 'SY' },
        { label: '+255', code: '255', full_code: '🇹🇿 +255', name: 'TZ' },
        { label: '+254', code: '254', full_code: '🇰🇪 +254', name: 'KE' },
        { label: '+256', code: '256', full_code: '🇺🇬 +256', name: 'UG' },
        { label: '+249', code: '249', full_code: '🇸🇩 +249', name: 'SD' },
        { label: '+251', code: '251', full_code: '🇪🇹 +251', name: 'ET' },
        { label: '+211', code: '211', full_code: '🇸🇸 +211', name: 'SS' },
        { label: '+250', code: '250', full_code: '🇷🇼 +250', name: 'RW' },
        { label: '+257', code: '257', full_code: '🇧🇮 +257', name: 'BI' },
        { label: '+253', code: '253', full_code: '🇩🇯 +253', name: 'DJ' },
        { label: '+235', code: '235', full_code: '🇹🇩 +235', name: 'TD' },
        { label: '+998', code: '998', full_code: '🇺🇿 +998', name: 'UZ' },
        { label: '+269', code: '269', full_code: '🇰🇲 +269', name: 'KM' },//new added country
        { label: '+93', code: '93', full_code: '🇦🇫 +93', name: 'AF' },
        { label: '+358', code: '358', full_code: '🇦🇽 +358', name: 'AX' },
        { label: '+355', code: '355', full_code: '🇦🇱 +355', name: 'AL' },
        { label: '+213', code: '213', full_code: '🇩🇿 +213', name: 'DZ' },
        { label: '+1684', code: '1684', full_code: '🇦🇸 +1684', name: 'AS' },
        { label: '+376', code: '376', full_code: '🇦🇩 +376', name: 'AD' },
        { label: '+244', code: '244', full_code: '🇦🇴 +244', name: 'AO' },
        { label: '+1264', code: '1264', full_code: '🇦🇮 +1264', name: 'AI' },
        { label: '+672', code: '672', full_code: '🇦🇶 +672', name: 'AQ' },
        { label: '+1268', code: '1268', full_code: '🇦🇬 +1268', name: 'AG' },
        { label: '+54', code: '54', full_code: '🇦🇷 +54', name: 'AR' },
        { label: '+374', code: '374', full_code: '🇦🇲 +374', name: 'AM' },
        { label: '+297', code: '297', full_code: '🇦🇼 +297', name: 'AW' },
        { label: '+1242', code: '1242', full_code: '🇧🇸 +1242', name: 'BS' },
        { label: '+1246', code: '1246', full_code: '🇧🇧 +1246', name: 'BB' },
        { label: '+375', code: '375', full_code: '🇧🇾 +375', name: 'BY' },
        { label: '+501', code: '501', full_code: '🇧🇿 +501', name: 'BZ' },
        { label: '+229', code: '229', full_code: '🇧🇯 +229', name: 'BJ' },
        { label: '+1441', code: '1441', full_code: '🇧🇲 +1441', name: 'BM' },
        { label: '+975', code: '975', full_code: '🇧🇹 +975', name: 'BT' },
        { label: '+591', code: '591', full_code: '🇧🇴 +591', name: 'BO' },
        { label: '+387', code: '387', full_code: '🇧🇦 +387', name: 'BA' },
        { label: '+267', code: '267', full_code: '🇧🇼 +267', name: 'BW' },
        { label: '+246', code: '246', full_code: '🇮🇴 +246', name: 'IO' },
        { label: '+1284', code: '1284', full_code: '🇻🇬 +1284', name: 'VG' },
        { label: '+673', code: '673', full_code: '🇧🇳 +673', name: 'BN' },
        { label: '+226', code: '226', full_code: '🇧🇫 +226', name: 'BF' },
        { label: '+855', code: '855', full_code: '🇰🇭 +855', name: 'KH' },
        { label: '+237', code: '237', full_code: '🇨🇲 +237', name: 'CM' },
        { label: '+1', code: '1', full_code: '🇨🇦 +1', name: 'CA' },
        { label: '+238', code: '238', full_code: '🇨🇻 +238', name: 'CV' },
        { label: '+599', code: '599', full_code: '🇧🇶 +599', name: 'BQ' },
        { label: '+1345', code: '1345', full_code: '🇰🇾 +1345', name: 'KY' },
        { label: '+236', code: '236', full_code: '🇨🇫 +236', name: 'CF' },
        { label: '+56', code: '56', full_code: '🇨🇱 +56', name: 'CL' },
        { label: '+61', code: '61', full_code: '🇨🇽 +61', name: 'CX' },
        { label: '+61', code: '61', full_code: '🇨🇨 +61', name: 'CC' },
        { label: '+57', code: '57', full_code: '🇨🇴 +57', name: 'CO' },
        { label: '+242', code: '242', full_code: '🇨🇬 +242', name: 'CG' },
        { label: '+243', code: '243', full_code: '🇨🇩 +243', name: 'CD' },
        { label: '+682', code: '682', full_code: '🇨🇰 +682', name: 'CK' },
        { label: '+506', code: '506', full_code: '🇨🇷 +506', name: 'CR' },
        { label: '+225', code: '225', full_code: '🇨🇮 +225', name: 'CI' },
        { label: '+385', code: '385', full_code: '🇭🇷 +385', name: 'HR' },
        { label: '+53', code: '53', full_code: '🇨🇺 +53', name: 'CU' },
        { label: '+599', code: '599', full_code: '🇨🇼 +599', name: 'CW' },
        { label: '+357', code: '357', full_code: '🇨🇾 +357', name: 'CY' },
        { label: '+45', code: '45', full_code: '🇩🇰 +45', name: 'DK' },
        { label: '+1767', code: '1767', full_code: '🇩🇲 +1767', name: 'DM' },
        { label: '+1809', code: '1809', full_code: '🇩🇴 +1809', name: 'DO' },
        { label: '+1829', code: '1829', full_code: '🇩🇴 +1829', name: 'DO' },
        { label: '+1849', code: '1849', full_code: '🇩🇴 +1849', name: 'DO' },
        { label: '+593', code: '593', full_code: '🇪🇨 +593', name: 'EC' },
        { label: '+503', code: '503', full_code: '🇸🇻 +503', name: 'SV' },
        { label: '+240', code: '240', full_code: '🇬🇶 +240', name: 'GQ' },
        { label: '+291', code: '291', full_code: '🇪🇷 +291', name: 'ER' },
        { label: '+372', code: '372', full_code: '🇪🇪 +372', name: 'EE' },
        { label: '+268', code: '268', full_code: '🇸🇿 +268', name: 'SZ' },
        { label: '+500', code: '500', full_code: '🇫🇰 +500', name: 'FK' },
        { label: '+298', code: '298', full_code: '🇫🇴 +298', name: 'FO' },
        { label: '+679', code: '679', full_code: '🇫🇯 +679', name: 'FJ' },
        { label: '+358', code: '358', full_code: '🇫🇮 +358', name: 'FI' },
        { label: '+594', code: '594', full_code: '🇬🇫 +594', name: 'GF' },
        { label: '+689', code: '689', full_code: '🇵🇫 +689', name: 'PF' },
        { label: '+241', code: '241', full_code: '🇬🇦 +241', name: 'GA' },
        { label: '+220', code: '220', full_code: '🇬🇲 +220', name: 'GM' },
        { label: '+995', code: '995', full_code: '🇬🇪 +995', name: 'GE' },
        { label: '+233', code: '233', full_code: '🇬🇭 +233', name: 'GH' },
        { label: '+350', code: '350', full_code: '🇬🇮 +350', name: 'GI' },
        { label: '+30', code: '30', full_code: '🇬🇷 +30', name: 'GR' },
        { label: '+299', code: '299', full_code: '🇬🇱 +299', name: 'GL' },
        { label: '+1473', code: '1473', full_code: '🇬🇩 +1473', name: 'GD' },
        { label: '+590', code: '590', full_code: '🇬🇵 +590', name: 'GP' },
        { label: '+1671', code: '1671', full_code: '🇬🇺 +1671', name: 'GU' },
        { label: '+502', code: '502', full_code: '🇬🇹 +502', name: 'GT' },
        { label: '+44', code: '44', full_code: '🇬🇬 +44', name: 'GG' },
        { label: '+224', code: '224', full_code: '🇬🇳 +224', name: 'GN' },
        { label: '+245', code: '245', full_code: '🇬🇼 +245', name: 'GW' },
        { label: '+592', code: '592', full_code: '🇬🇾 +592', name: 'GY' },
        { label: '+509', code: '509', full_code: '🇭🇹 +509', name: 'HT' },
        { label: '+504', code: '504', full_code: '🇭🇳 +504', name: 'HN' },
        { label: '+852', code: '852', full_code: '🇭🇰 +852', name: 'HK' },
        { label: '+354', code: '354', full_code: '🇮🇸 +354', name: 'IS' },
        { label: '+98', code: '98', full_code: '🇮🇷 +98', name: 'IR' },
        { label: '+44', code: '44', full_code: '🇮🇲 +44', name: 'IM' },
        { label: '+972', code: '972', full_code: '🇮🇱 +972', name: 'IL' },
        { label: '+1876', code: '1876', full_code: '🇯🇲 +1876', name: 'JM' },
        { label: '+44', code: '44', full_code: '🇯🇪 +44', name: 'JE' },
        { label: '+7', code: '7', full_code: '🇰🇿 +7', name: 'KZ' },
        { label: '+686', code: '686', full_code: '🇰🇮 +686', name: 'KI' },
        { label: '+383', code: '383', full_code: '🇽🇰 +383', name: 'XK' },
        { label: '+996', code: '996', full_code: '🇰🇬 +996', name: 'KG' },
        { label: '+856', code: '856', full_code: '🇱🇦 +856', name: 'LA' },
        { label: '+371', code: '371', full_code: '🇱🇻 +371', name: 'LV' },
        { label: '+266', code: '266', full_code: '🇱🇸 +266', name: 'LS' },
        { label: '+231', code: '231', full_code: '🇱🇷 +231', name: 'LR' },
        { label: '+218', code: '218', full_code: '🇱🇾 +218', name: 'LY' },
        { label: '+423', code: '423', full_code: '🇱🇮 +423', name: 'LI' },
        { label: '+370', code: '370', full_code: '🇱🇹 +370', name: 'LT' },
        { label: '+352', code: '352', full_code: '🇱🇺 +352', name: 'LU' },
        { label: '+853', code: '853', full_code: '🇲🇴 +853', name: 'MO' },
        { label: '+261', code: '261', full_code: '🇲🇬 +261', name: 'MG' },
        { label: '+265', code: '265', full_code: '🇲🇼 +265', name: 'MW' },
        { label: '+960', code: '960', full_code: '🇲🇻 +960', name: 'MV' },
        { label: '+223', code: '223', full_code: '🇲🇱 +223', name: 'ML' },
        { label: '+356', code: '356', full_code: '🇲🇹 +356', name: 'MT' },
        { label: '+692', code: '692', full_code: '🇲🇭 +692', name: 'MH' },
        { label: '+596', code: '596', full_code: '🇲🇶 +596', name: 'MQ' },
        { label: '+222', code: '222', full_code: '🇲🇷 +222', name: 'MR' },
        { label: '+230', code: '230', full_code: '🇲🇺 +230', name: 'MU' },
        { label: '+262', code: '262', full_code: '🇾🇹 +262', name: 'YT' },
        { label: '+691', code: '691', full_code: '🇫🇲 +691', name: 'FM' },
        { label: '+373', code: '373', full_code: '🇲🇩 +373', name: 'MD' },
        { label: '+377', code: '377', full_code: '🇲🇨 +377', name: 'MC' },
        { label: '+976', code: '976', full_code: '🇲🇳 +976', name: 'MN' },
        { label: '+382', code: '382', full_code: '🇲🇪 +382', name: 'ME' },
        { label: '+1664', code: '1664', full_code: '🇲🇸 +1664', name: 'MS' },
        { label: '+212', code: '212', full_code: '🇲🇦 +212', name: 'MA' },
        { label: '+258', code: '258', full_code: '🇲🇿 +258', name: 'MZ' },
        { label: '+95', code: '95', full_code: '🇲🇲 +95', name: 'MM' },
        { label: '+264', code: '264', full_code: '🇳🇦 +264', name: 'NA' },
        { label: '+674', code: '674', full_code: '🇳🇷 +674', name: 'NR' },
        { label: '+687', code: '687', full_code: '🇳🇨 +687', name: 'NC' },
        { label: '+64', code: '64', full_code: '🇳🇿 +64', name: 'NZ' },
        { label: '+505', code: '505', full_code: '🇳🇮 +505', name: 'NI' },
        { label: '+227', code: '227', full_code: '🇳🇪 +227', name: 'NE' },
        { label: '+234', code: '234', full_code: '🇳🇬 +234', name: 'NG' },
        { label: '+683', code: '683', full_code: '🇳🇺 +683', name: 'NU' },
        { label: '+672', code: '672', full_code: '🇳🇫 +672', name: 'NF' },
        { label: '+850', code: '850', full_code: '🇰🇵 +850', name: 'KP' },
        { label: '+389', code: '389', full_code: '🇲🇰 +389', name: 'MK' },
        { label: '+1670', code: '1670', full_code: '🇲🇵 +1670', name: 'MP' },
        { label: '+680', code: '680', full_code: '🇵🇼 +680', name: 'PW' },
        { label: '+970', code: '970', full_code: '🇵🇸 +970', name: 'PS' },
        { label: '+507', code: '507', full_code: '🇵🇦 +507', name: 'PA' },
        { label: '+675', code: '675', full_code: '🇵🇬 +675', name: 'PG' },
        { label: '+595', code: '595', full_code: '🇵🇾 +595', name: 'PY' },
        { label: '+51', code: '51', full_code: '🇵🇪 +51', name: 'PE' },
        { label: '+64', code: '64', full_code: '🇵🇳 +64', name: 'PN' },
        { label: '+1787', code: '1787', full_code: '🇵🇷 +1787', name: 'PR' },
        { label: '+1939', code: '1939', full_code: '🇵🇷 +1939', name: 'PR' },
        { label: '+262', code: '262', full_code: '🇷🇪 +262', name: 'RE' },
        { label: '+590', code: '590', full_code: '🇧🇱 +590', name: 'BL' },
        { label: '+290', code: '290', full_code: '🇸🇭 +290', name: 'SH' },
        { label: '+1869', code: '1869', full_code: '🇰🇳 +1869', name: 'KN' },
        { label: '+1758', code: '1758', full_code: '🇱🇨 +1758', name: 'LC' },
        { label: '+590', code: '590', full_code: '🇲🇫 +590', name: 'MF' },
        { label: '+508', code: '508', full_code: '🇵🇲 +508', name: 'PM' },
        { label: '+1784', code: '1784', full_code: '🇻🇨 +1784', name: 'VC' },
        { label: '+685', code: '685', full_code: '🇼🇸 +685', name: 'WS' },
        { label: '+378', code: '378', full_code: '🇸🇲 +378', name: 'SM' },
        { label: '+239', code: '239', full_code: '🇸🇹 +239', name: 'ST' },
        { label: '+221', code: '221', full_code: '🇸🇳 +221', name: 'SN' },
        { label: '+381', code: '381', full_code: '🇷🇸 +381', name: 'RS' },
        { label: '+232', code: '232', full_code: '🇸🇱 +232', name: 'SL' },
        { label: '+1721', code: '1721', full_code: '🇸🇽 +1721', name: 'SX' },
        { label: '+386', code: '386', full_code: '🇸🇮 +386', name: 'SI' },
        { label: '+677', code: '677', full_code: '🇸🇧 +677', name: 'SB' },
        { label: '+252', code: '252', full_code: '🇸🇴 +252', name: 'SO' },
        { label: '+500', code: '500', full_code: '🇬🇸 +500', name: 'GS' },
        { label: '+597', code: '597', full_code: '🇸🇷 +597', name: 'SR' },
        { label: '+47', code: '47', full_code: '🇸🇯 +47', name: 'SJ' },
        { label: '+886', code: '886', full_code: '🇹🇼 +886', name: 'TW' },
        { label: '+992', code: '992', full_code: '🇹🇯 +992', name: 'TJ' },
        { label: '+670', code: '670', full_code: '🇹🇱 +670', name: 'TL' },
        { label: '+228', code: '228', full_code: '🇹🇬 +228', name: 'TG' },
        { label: '+690', code: '690', full_code: '🇹🇰 +690', name: 'TK' },
        { label: '+676', code: '676', full_code: '🇹🇴 +676', name: 'TO' },
        { label: '+1868', code: '1868', full_code: '🇹🇹 +1868', name: 'TT' },
        { label: '+216', code: '216', full_code: '🇹🇳 +216', name: 'TN' },
        { label: '+993', code: '993', full_code: '🇹🇲 +993', name: 'TM' },
        { label: '+1649', code: '1649', full_code: '🇹🇨 +1649', name: 'TC' },
        { label: '+688', code: '688', full_code: '🇹🇻 +688', name: 'TV' },
        { label: '+1340', code: '1340', full_code: '🇻🇮 +1340', name: 'VI' },
        { label: '+598', code: '598', full_code: '🇺🇾 +598', name: 'UY' },
        { label: '+678', code: '678', full_code: '🇻🇺 +678', name: 'VU' },
        { label: '+379', code: '379', full_code: '🇻🇦 +379', name: 'VA' },
        { label: '+58', code: '58', full_code: '🇻🇪 +58', name: 'VE' },
        { label: '+84', code: '84', full_code: '🇻🇳 +84', name: 'VN' },
        { label: '+681', code: '681', full_code: '🇼🇫 +681', name: 'WF' },
        { label: '+212', code: '212', full_code: '🇪🇭 +212', name: 'EH' },
        { label: '+967', code: '967', full_code: '🇾🇪 +967', name: 'YE' },
        { label: '+260', code: '260', full_code: '🇿🇲 +260', name: 'ZM' },
        { label: '+263', code: '263', full_code: '🇿🇼 +263', name: 'ZW' }
    ];
}